import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './Sections.module.css';
import { PrimaryButton } from '../../../components';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { createResourceLocatorString } from '../../../util/routes';
import routeConfiguration from '../../../routing/routeConfiguration';
function VisitSupplierSection() {
  const history = useHistory();
  const redirectToTrustedSuppliers = () => {
    history.push(createResourceLocatorString('TrustedSuppliersPage', routeConfiguration(), {}, {}));
  };
  return (
    <div className={css.trustedSupplierSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.trustedSupplierInfo}>
          <h2>
            <FormattedMessage id="ArchitectsAndPlanningConsultancyPage.VisitSupplierSection.title" />
          </h2>
          <p>
            <FormattedMessage id="ArchitectsAndPlanningConsultancyPage.VisitSupplierSection.description" />
          </p>
          <PrimaryButton
            className={css.trustedSupplierBtn}
            type="button"
            onClick={redirectToTrustedSuppliers}
          >
            <FormattedMessage id="ArchitectsAndPlanningConsultancyPage.VisitSupplierSection.button" />
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}

export default VisitSupplierSection;
